module.exports = __webpack_public_path__ + "img/r4.70b17b52.jpg";